module.exports = __webpack_public_path__ + "494ad8881c0ff328b1d68aa9f6934ffb.svg";